import './SearchPublisherResult.scss'

import { ResultsItemType } from '@react/SearchResults/SearchTypes'
import { ReactElement } from 'react'

export type SearchResultProps = {
  result: ResultsItemType
  label: string
}

const nullCheck = (value: string): string => {
  return value && value !== 'null' ? value : ''
}

export function SearchPublisherResult({ result, label }: SearchResultProps): ReactElement {
  const doctId = nullCheck(result.identification.documentNumber)
  const docLang = nullCheck(result.displayTitle.languageCode)
  const url = `https://publisher.hitachienergy.com/preview?DocumentID=${doctId}&LanguageCode=${docLang}`
  return (
    <div className="saas-result__item saas-publisher_result__item" data-testid="search-result">
      <a href={url} className="saas-result__product-url" target="_blank" rel="noreferrer noopener">
        <div className="saas-result__meta" tabIndex={0}>
          <header className="saas-result__header" tabIndex={0}>
            {result.bestBet && (
              <span className="saas-result__top-result-badge" data-testid="search-result-label" dangerouslySetInnerHTML={{ __html: label }}></span>
            )}
            {result.displayTitle.title && (
            <h6
              className="saas-result__title saas-publisher_result__title"
              data-testid="search-result-title"
                dangerouslySetInnerHTML={{ __html: nullCheck(result.displayTitle.title) }}
            />
            )}
          </header>
          <div className="saas-result__outline saas-publisher_result__outline saas-result__summary">
            {<span tabIndex={0} dangerouslySetInnerHTML={{ __html: nullCheck(result.summary) }} />}
          </div>
          <div className="saas-result__outline saas-publisher_result__outline">
            <span tabIndex={0}>Document ID : {doctId}</span> | <span tabIndex={0}>Document Language : {docLang.toUpperCase()}</span>
          </div>
          <div className="saas-result__outline saas-publisher_result__outline">
            <span tabIndex={0}>Type Of Document : {nullCheck(result.documentType)}</span> |{' '}
            <span tabIndex={0}>Revision Date : {nullCheck(result.revisionDate)}</span>
          </div>
          <div className="saas-result__outline saas-publisher_result__outline">
            <span tabIndex={0}>
              File Size : {nullCheck(result.fileSize)}
              {nullCheck(result.fileUnit)}
            </span>{' '}
            | <span tabIndex={0}>File Format : {nullCheck(result.fileExtension).toUpperCase()}</span>
          </div>
          <div className="saas-result__outline saas-publisher_result__outline">
            <span className="saas-result__path saas-publisher_result__path" tabIndex={0} data-testid="search-result-url">
              {url}
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}
